import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { __, sprintf } from '@wordpress/i18n';
import { Button, Icon } from '@wordpress/components';
import classnames from 'classnames';
import { Component } from '@wordpress/element';
import { findIndex } from 'lodash';
import PropTypes from 'prop-types';
/**
 * Internal dependencies
 */

import Tag from '../tag';
/**
 * A list of tags to display selected items.
 */

var Tags =
/*#__PURE__*/
function (_Component) {
  _inherits(Tags, _Component);

  function Tags(props) {
    var _this;

    _classCallCheck(this, Tags);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tags).call(this, props));
    _this.removeAll = _this.removeAll.bind(_assertThisInitialized(_this));
    _this.removeResult = _this.removeResult.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tags, [{
    key: "removeAll",
    value: function removeAll() {
      var onChange = this.props.onChange;
      onChange([]);
    }
  }, {
    key: "removeResult",
    value: function removeResult(key) {
      var _this2 = this;

      return function () {
        var _this2$props = _this2.props,
            selected = _this2$props.selected,
            onChange = _this2$props.onChange;
        var i = findIndex(selected, {
          key: key
        });
        onChange([].concat(_toConsumableArray(selected.slice(0, i)), _toConsumableArray(selected.slice(i + 1))));
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          selected = _this$props.selected,
          showClearButton = _this$props.showClearButton;

      if (!selected.length) {
        return null;
      }

      var classes = classnames('woocommerce-select-control__tags', {
        'has-clear': showClearButton
      });
      return createElement("div", {
        className: classes
      }, selected.map(function (item, i) {
        if (!item.label) {
          return null;
        }

        var screenReaderLabel = sprintf(__('%1$s (%2$s of %3$s)', 'woocommerce-admin'), item.label, i + 1, selected.length);
        return createElement(Tag, {
          key: item.key,
          id: item.key,
          label: item.label,
          remove: _this3.removeResult,
          screenReaderLabel: screenReaderLabel
        });
      }), showClearButton && createElement(Button, {
        className: "woocommerce-select-control__clear",
        isLink: true,
        onClick: this.removeAll
      }, createElement(Icon, {
        icon: "dismiss"
      }), createElement("span", {
        className: "screen-reader-text"
      }, __('Clear all', 'woocommerce-admin'))));
    }
  }]);

  return Tags;
}(Component);

Tags.propTypes = {
  /**
   * Function called when selected results change, passed result list.
   */
  onChange: PropTypes.func,

  /**
   * Function to execute when an option is selected.
   */
  onSelect: PropTypes.func,

  /**
   * An array of objects describing selected values. If the label of the selected
   * value is omitted, the Tag of that value will not be rendered inside the
   * search box.
   */
  selected: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    label: PropTypes.string
  })),

  /**
   * Render a 'Clear' button next to the input box to remove its contents.
   */
  showClearButton: PropTypes.bool
};
export default Tags;
//# sourceMappingURL=tags.js.map